import { render, staticRenderFns } from "./mediaDialog.vue?vue&type=template&id=939f75ee&"
import script from "./mediaDialog.vue?vue&type=script&lang=js&"
export * from "./mediaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports